<template>
  <v-row>
    <v-col lg="8" md="8" cols="12">
      <v-card outlined>
        <v-card-title class="d-flex">
          <span>GMR</span>
        </v-card-title>
        <v-card-text>
          <p class="subtitle-2 mb-1" style="color: rgba(0,0,0,0.7)">
            Garantia Mínima de Resultado
          </p>
          <p class="caption mb-4" style="color: rgba(0,0,0,0.55)">
            Defina a garantia mínima de resultado da campanha.
          </p>

          <!-- Card Vincular GMR -->
          <div
            style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 14px 16px; background: rgba(0,0,0,0.015)"
          >
            <div class="d-flex align-center justify-space-between">
              <div>
                <p
                  class="body-2 font-weight-medium ma-0"
                  style="color: rgba(0,0,0,0.7)"
                >
                  Vincular GMR
                </p>
                <p class="caption ma-0 mt-1" style="color: rgba(0,0,0,0.55)">
                  Garantia Mínima de Resultado
                </p>
              </div>
              <v-switch
                v-model="ativarGMR"
                inset
                dense
                hide-details
                class="mt-0 pt-0 flex-shrink-0"
              ></v-switch>
            </div>

            <div v-if="ativarGMR" class="mt-4" style="display: flex; flex-direction: column; gap: 12px">
              <!-- Indicador do realizado GMR -->
              <div>
                <p
                  class="caption font-weight-bold text-uppercase ma-0 mb-2"
                  style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)"
                >
                  Indicador do Realizado
                </p>
                <v-autocomplete
                  v-model="indicadorSelecionado"
                  :items="indicadores"
                  :item-text="item => `${item.id_indicador} - ${item.indicador}`"
                  item-value="id_indicador"
                  outlined
                  dense
                  clearable
                  background-color="white"
                  placeholder="Selecione o indicador"
                  :loading="loadingIndicadores"
                  no-data-text="Nenhum indicador encontrado"
                >
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on">
                      <v-list-item-title style="color: rgba(0,0,0,0.87); font-weight: 500">
                        {{ item.id_indicador }} - {{ item.indicador }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span style="color: rgba(0,0,0,0.87); font-weight: 500">
                      {{ item.id_indicador }} - {{ item.indicador }}
                    </span>
                  </template>
                </v-autocomplete>
              </div>

              <div class="d-flex" style="gap: 16px">
                <!-- Percentual GMR -->
                <div style="flex: 1">
                  <p
                    class="caption font-weight-bold text-uppercase ma-0 mb-2"
                    style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)"
                  >
                    Percentual GMR (%)
                  </p>
                  <v-text-field
                    v-model="percentualGMR"
                    type="number"
                    outlined
                    dense
                    placeholder="5"
                    suffix="%"
                    background-color="white"
                    :error-messages="erroPercentualGMR"
                  ></v-text-field>
                </div>

                <!-- Dobro GMR -->
                <div style="flex: 1">
                  <p
                    class="caption font-weight-bold text-uppercase ma-0 mb-2"
                    style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)"
                  >
                    Dobro GMR (%)
                  </p>
                  <v-text-field
                    v-model="percentualDobro"
                    type="number"
                    outlined
                    dense
                    placeholder="0"
                    suffix="%"
                    background-color="white"
                    :error-messages="erroPercentualDobro"
                  ></v-text-field>
                  <p v-if="erroPercentualDobro.length === 0" class="caption mt-1" style="color: rgba(0,0,0,0.55)">
                    Se preenchido, o bônus será dobrado ao atingir este percentual.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col lg="4" md="4" cols="12">
      <ResumoCampanhaCard
        :etapa="4"
        :id-campanha="$route.params.idCampanha"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import http, { getApiError } from "@/services/http";
import campanhas from "@/services/http/campanhaService";
import ResumoCampanhaCard from "@/components/campanha/cadastro/ResumoCampanhaCard";

export default {
  name: "FormVinculaGmrCampanha",

  components: {
    ResumoCampanhaCard
  },

  data() {
    return {
      loading: false,
      ativarGMR: false,
      percentualGMR: null,
      percentualDobro: null,
      indicadorSelecionado: null,
      indicadores: [],
      loadingIndicadores: false
    };
  },

  computed: {
    ...mapGetters({
      getMetasCadastradas: "campanha/getMetasCadastradas"
    }),

    erroPercentualGMR() {
      if (!this.ativarGMR || !this.percentualGMR) return [];
      return parseFloat(this.percentualGMR) < 5
        ? ["Deve ser maior ou igual a 5%"]
        : [];
    },

    erroPercentualDobro() {
      if (!this.ativarGMR || !this.percentualDobro || !this.percentualGMR) return [];
      return parseFloat(this.percentualDobro) <= parseFloat(this.percentualGMR)
        ? ["Deve ser maior que o percentual GMR"]
        : [];
    },

    gmrValido() {
      if (!this.ativarGMR) return true;
      if (!this.indicadorSelecionado) return false;
      if (!this.percentualGMR) return false;
      if (this.erroPercentualGMR.length > 0) return false;
      if (this.erroPercentualDobro.length > 0) return false;
      return true;
    },

  },

  watch: {
    gmrValido: {
      immediate: true,
      handler(val) {
        this.$store.commit("campanha/setStatusGmr", val);
      }
    },
    ativarGMR(val) {
      if (val && this.indicadores.length === 0) {
        this.carregarIndicadores();
      }
      if (!val) {
        this.indicadorSelecionado = null;
      }
    }
  },

  methods: {
    ...mapActions({
      actionEmpresasParticipantes: "campanha/actionEmpresasParticipantes"
    }),

    async carregarIndicadores() {
      this.loadingIndicadores = true;
      try {
        const { data } = await http.get("/sistemas/indicadores", {
          params: { ativo: "S", ativa_campanha: "S", per_page: -1 }
        });
        this.indicadores = data.data || [];
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao carregar indicadores") });
      } finally {
        this.loadingIndicadores = false;
      }
    },

    voltar() {
      this.$router.go(-1);
    },

    async salvar() {
      this.loading = true;
      try {
        const id = this.$route.params.idCampanha;
        const payload = { id_campanha: id, vincula: this.ativarGMR };
        if (this.ativarGMR) {
          payload.id_indicador = this.indicadorSelecionado;
          payload.percentual_gmr = parseFloat(this.percentualGMR) || null;
          payload.percentual_dobro = parseFloat(this.percentualDobro) || null;
        }
        await campanhas().metasCampanhaGmr().store(payload);

        this.$notify({ type: "success", text: "GMR salvo com sucesso!" });
        const base = this.$route.path.substring(0, this.$route.path.lastIndexOf("/"));
        this.$router.push(`${base}/resumo`);
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao salvar o GMR.") });
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    const id = this.$route.params.idCampanha;
    if (!id) return;

    await this.actionEmpresasParticipantes(id);

    if (!this.getMetasCadastradas.length) {
      try {
        const resMetas = await campanhas().metasCampanha().show({ id_campanha: id, per_page: -1 });
        const metas = Array.isArray(resMetas?.data) ? resMetas.data : resMetas?.data?.data || [];
        this.$store.commit("campanha/setMetasCadastradas", { data: metas });
      } catch { /* metas ficam vazias */ }
    }

    try {
      const resGmr = await campanhas().metasCampanhaGmr().show({ id_campanha: id });
      const lista = Array.isArray(resGmr?.data) ? resGmr.data : resGmr?.data?.data || [];
      const gmr = lista[0];
      if (gmr && (gmr.vincula === "S" || gmr.vincula === true || gmr.vincula === 1)) {
        await this.carregarIndicadores();
        this.ativarGMR = true;
        await this.$nextTick();
        this.indicadorSelecionado = gmr.id_indicador ? Number(gmr.id_indicador) : null;
        this.percentualGMR = gmr.percentual_gmr != null ? String(gmr.percentual_gmr) : null;
        this.percentualDobro = gmr.percentual_dobro != null ? String(gmr.percentual_dobro) : null;
      }
    } catch { /* sem dados GMR, mantém padrão */ }
  }
};
</script>
